<!--
     <LoadingScreen
       show
     />

     Properties:
       - show
-->

<template>
  <div>
    <div class="loadingscreen-cont" v-if="show">
      <img
        class="loadingscreen-img"
        :src="qmkey_icon"
      />

      <div class="loadingscreen-progress-cont">
        <v-progress-linear
          indeterminate
          size="64"
          color="primary"
        />
      </div>
    </div>
  </div>
</template>


<style lang="scss">
 .loadingscreen-cont {
   position: fixed;
   top: 0;
   left: 0;
   width: 100vw;
   height: 100vh;
   z-index: 2069;
   display: flex;
   background-color: white;
   align-items: center;
   justify-content: center;
   flex-direction: column;
   gap: 5px;
 }

 .loadingscreen-img {
   width: 200px;
   max-height: 200px;
   object-fit: scale;
 }

 .loadingscreen-progress-cont {
   width: 200px;
 }
</style>


<script>
 import customThemes from '@/plugins/themes.js'
 import { mapState } from 'vuex'

 export default {
   name: 'LoadingScreen',

   props: {
     show: {type: Boolean, default: false},
   },

   data: () => ({

   }),

   computed: {
     ...mapState(['currentTheme']),

     qmkey_icon() {
       return (customThemes[this.currentTheme] || {}).logo || customThemes.logo;
     },
   },
 };
</script>
